import * as printJS from "print-js";

export async function raiseTicket(formData) {
  const token = localStorage.getItem("token");
  const url = `${process.env.REACT_APP_API}/v1/api/raise/ticket`;

  const rawResponse = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function getCategory() {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/all-ticket-category`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function getSubCategory(id) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/subticket/category/${id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function getTicketType(id) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/subticket/type/${id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function getTickets(queryParams) {
  const queryString = Object.keys(queryParams)
    .map((key) => {
      if (queryParams[key]) {
        return `${key}=${queryParams[key]}`;
      }
      return "";
    })
    .filter((value) => value !== "")
    .join("&");
  try {
    const token = localStorage.getItem("token");
    const rawResponse = await fetch(
      process.env.REACT_APP_API + `/v1/api/fetch/tickets/?${queryString}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const content = await rawResponse.json();
    if (rawResponse.status === 200) {
      return { body: content.body, success: true, message: "" };
    } else {
      return { body: [], success: false, message: content.message };
    }
  } catch (e) {
    console.error(e);
    return {
      data: undefined,
      success: false,
      message: "Somthing went wrong !",
    };
  }
}

export async function getHistoryTickets(id) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/fetch-ticket/${id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function downloadTicketHistory(id) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API}/v1/api/download/ticket/${id}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
        body: "",
      }
    );

    const content = await response.json();
    if (response.status === 200) {
      const byteCharacters = atob(content.body);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const blobURL = URL.createObjectURL(blob);
      printJS(blobURL);
      return { success: true, message: "" };
    }
  } catch (error) {
    return {
      success: false,
      message: "An error occurred while downloading the file.",
    };
  }
}

export async function freezeTicketHistory(id) {
  const response = await fetch(
    `${process.env.REACT_APP_API}/v1/api/freeze-ticket/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
      body: "",
    }
  );

  if (response.ok) {
    const blob = await response.blob();
    var blobURL = URL.createObjectURL(blob);
    printJS(blobURL);

    return { success: true, message: "" };
  } else {
    const content = await response.json();
    return { success: false, message: content.message };
  }
}

export async function createTicketTemplate(formData) {
  const token = localStorage.getItem("token");
  const url = `${process.env.REACT_APP_API}/v1/api/create/reply-template`;

  const rawResponse = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(formData),
  });

  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function replyTicket(formData, id) {
  const token = localStorage.getItem("token");
  const url = `${process.env.REACT_APP_API}/v1/api/reply-ticket/${id}`;

  const rawResponse = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function getTicketTemplate(queryParams) {
  const queryString = Object.keys(queryParams)
    .map((key) => {
      if (queryParams[key]) {
        return `${key}=${queryParams[key]}`;
      }
      return "";
    })
    .filter((value) => value !== "")
    .join("&");
  try {
    const token = localStorage.getItem("token");
    const rawResponse = await fetch(
      process.env.REACT_APP_API +
        `/v1/api/fetch-reply-templates?${queryString}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const content = await rawResponse.json();
    if (rawResponse.status === 200) {
      return { body: content.body, success: true, message: "" };
    } else {
      return { body: [], success: false, message: content.message };
    }
  } catch (e) {
    console.error(e);
    return {
      data: undefined,
      success: false,
      message: "Somthing went wrong !",
    };
  }
}

export async function deleteTicketsTemplate(id) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/delete/template/${id}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function getLabels(queryParams) {
  const queryString = Object.keys(queryParams)
    .map((key) => {
      if (queryParams[key]) {
        return `${key}=${queryParams[key]}`;
      }
      return "";
    })
    .filter((value) => value !== "")
    .join("&");
  try {
    const token = localStorage.getItem("token");
    const rawResponse = await fetch(
      process.env.REACT_APP_API + `/v1/api/fetch-ticket-labels?${queryString}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const content = await rawResponse.json();
    if (rawResponse.status === 200) {
      return { body: content.body, success: true, message: "" };
    } else {
      return { body: [], success: false, message: content.message };
    }
  } catch (e) {
    console.error(e);
    return {
      data: undefined,
      success: false,
      message: "Somthing went wrong !",
    };
  }
}

export async function getTicketLabels() {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/fetch-ticket-labels`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function createlabel(formData) {
  const token = localStorage.getItem("token");
  const url = `${process.env.REACT_APP_API}/v1/api/create/ticket-labels`;

  const rawResponse = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(formData),
  });

  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function deleteLabel(id) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/delete/ticket-label/${id}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function addLabels(formData) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/create-ticket-label-mapping`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function getTicketLabelListing(queryParams, id) {
  const queryString = Object.keys(queryParams)
    .map((key) => {
      if (queryParams[key]) {
        return `${key}=${queryParams[key]}`;
      }
      return "";
    })
    .filter((value) => value !== "")
    .join("&");
  try {
    const token = localStorage.getItem("token");
    const rawResponse = await fetch(
      process.env.REACT_APP_API +
        `/v1/api/fetch-ticket-label-mapping/${id}?${queryString}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const content = await rawResponse.json();
    if (rawResponse.status === 200) {
      return { body: content.body, success: true, message: "" };
    } else {
      return { body: [], success: false, message: content.message };
    }
  } catch (e) {
    console.error(e);
    return {
      data: undefined,
      success: false,
      message: "Somthing went wrong !",
    };
  }
}

export async function search(queryParams) {
  const queryString = Object.keys(queryParams)
    .map((key) => {
      if (queryParams[key]) {
        return `${key}=${queryParams[key]}`;
      }
      return "";
    })
    .filter((value) => value !== "")
    .join("&");
  try {
    const token = localStorage.getItem("token");
    const rawResponse = await fetch(
      process.env.REACT_APP_API + `/v1/api/fetch-tickets?${queryString}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const content = await rawResponse.json();
    if (rawResponse.status === 200) {
      return { body: content.body, success: true, message: "" };
    } else {
      return { body: [], success: false, message: content.message };
    }
  } catch (e) {
    console.error(e);
    return {
      data: undefined,
      success: false,
      message: "Somthing went wrong !",
    };
  }
}

export async function replyTicketFromTemplate(formData) {
  const token = localStorage.getItem("token");
  const url = `${process.env.REACT_APP_API}/v1/api/reply/tickets-from-template`;

  const rawResponse = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function fetchStatus() {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/status`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function unasignTicketLabel(ticketId) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API +
      `/v1/api/unassign-ticket-from-label?ticketId=${ticketId}`,
    {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function fetchAttachments(id) {
  try {
    const token = localStorage.getItem("token");
    const rawResponse = await fetch(
      process.env.REACT_APP_API + `/v1/api/fetch-attachment/${id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const content = await rawResponse.json();
    if (rawResponse.status === 200) {
      return { body: content.body, success: true, message: "" };
    } else {
      return { body: [], success: false, message: content.message };
    }
  } catch (e) {
    console.error(e);
    return {
      data: undefined,
      success: false,
      message: "Somthing went wrong !",
    };
  }
}

export async function replyReOpenTicket(formData) {
  const token = localStorage.getItem("token");
  const url = `${process.env.REACT_APP_API}/v1/api/reopen/ticket`;

  const rawResponse = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function getAdvertisements() {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/advertisements`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function getPosts(id) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/advertisements/posts/${id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}
